import React, { useState, useEffect } from "react"
import { Link, useLocation } from "react-router-dom"
import {
    Col,
    Container,
    Form,
    Row,
    Input,
    Label,
    FormFeedback,
    Alert,
} from "reactstrap"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import { toast } from "sonner"

// import images

//redux
import { useSelector, useDispatch } from "react-redux"

import { loginUser } from "../../store/actions"

// import components
import FullPageLoader from "components/Common/FullPageLoader"
import EnvironmentBadge from "components/Common/EnvironmentBadge"

const Login2 = props => {
    const [passwordShow, setPasswordShow] = useState(false)
    const [prefilledUsername, setPrefilledUsername] = useState(null)

    const dispatch = useDispatch()
    const location = useLocation()

    const appName = process.env.REACT_APP_APP_NAME || "CMS"

    //meta title
    document.title = "Login"

    // Parse URL parameter for username
    useEffect(() => {
        // Use window.location.search as a fallback for S3 deployment
        const searchString = location.search || window.location.search
        const searchParams = new URLSearchParams(searchString)
        const encodedUsername = searchParams.get("u")
        if (encodedUsername) {
            try {
                const decodedUsername = atob(encodedUsername)
                setPrefilledUsername(decodedUsername)
            } catch (error) {
                 setTimeout(() => {
                    toast.error("Invalid username encoding")
                }, 100)
            }
        }
    }, [location.search])

    // Form validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            username: prefilledUsername || "",
            password: "",
        },
        validationSchema: Yup.object({
            username: Yup.string().required("Please Enter Your Username"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: async values => {
            dispatch(loginUser(values, props.history))
        },
    })

    const { loginError, loginSuccessMsg, loading } = useSelector(state => ({
        loginError: state.Login.error.message || state.Login.error.description,
        loginSuccessMsg: "Logged in successfully",
        loading: state.Login.loading,
    }))

    return (
        <React.Fragment>
            <FullPageLoader show={loading} message="Signing you in..." />
            <EnvironmentBadge position="top-right" />
            <div className="d-flex" style={{ minHeight: '100vh', margin: 0, padding: 0 }}>
                <div className="w-100 d-flex">
                    <div className="d-none d-lg-block" style={{ width: '66.66%' }}>
                        <div className="d-flex align-items-center justify-content-center" style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            minHeight: '100vh',
                            width: '100%'
                        }}>
                            <div className="text-center text-white p-5">
                                <h1 className="display-6 mb-4">{appName}</h1>
                                <h2 className="display-4 fw-bold mb-4">Welcome Back!</h2>
                                <p className="lead mb-0">Sign in to continue to your dashboard</p>
                            </div>
                        </div>
                    </div>
                    <div className="flex-fill d-flex">
                        <div className="auth-full-page-content p-md-5 p-4 d-flex align-items-center justify-content-center min-vh-100 w-100">
                            <div className="w-100" style={{ maxWidth: '400px' }}>
                                <div className="d-flex flex-column h-100">
                                    <div className="mb-4 mb-md-5">
                                        <a href={process.env.REACT_APP_LANDING_PAGE_URL} className="d-block auth-logo">
                                            <i className="mdi mdi-arrow-left mr-2"></i>
                                            Go Back to applications
                                        </a>
                                    </div>
                                    <div className="my-auto">
                                        <div className="mt-4">
                                            <Form
                                                className="form-horizontal"
                                                onSubmit={e => {
                                                    e.preventDefault()
                                                    validation.handleSubmit()
                                                    return false
                                                }}
                                            >
                                                <div className="mb-3">
                                                    <Label className="form-label">Email</Label>
                                                    <Input
                                                        name="username"
                                                        className="form-control"
                                                        placeholder="Enter username"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.username || ""}
                                                        invalid={
                                                            validation.touched.username &&
                                                                validation.errors.username
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    {validation.touched.username &&
                                                        validation.errors.username ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.username}
                                                        </FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3">
                                                    <div className="float-end">
                                                        <Link
                                                            to="/forgot-password"
                                                            className="text-muted"
                                                        >
                                                            Forgot password?
                                                        </Link>
                                                    </div>
                                                    <Label className="form-label">Password</Label>
                                                    <div className="input-group auth-pass-inputgroup">
                                                        <Input
                                                            name="password"
                                                            value={validation.values.password || ""}
                                                            type={passwordShow ? "text" : "password"}
                                                            placeholder="Enter Password"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={
                                                                validation.touched.password &&
                                                                    validation.errors.password
                                                                    ? true
                                                                    : false
                                                            }
                                                        />
                                                        <button
                                                            onClick={() => setPasswordShow(!passwordShow)}
                                                            className="btn btn-light "
                                                            type="button"
                                                            id="password-addon"
                                                        >
                                                            <i className="mdi mdi-eye-outline"></i>
                                                        </button>
                                                    </div>
                                                    {validation.touched.password &&
                                                        validation.errors.password ? (
                                                        <FormFeedback type="invalid">
                                                            {validation.errors.password}
                                                        </FormFeedback>
                                                    ) : null}
                                                </div>

                                                {/* <div className="form-check">
                            <Input
                              type="checkbox"
                              className="form-check-input"
                              id="auth-remember-check"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="auth-remember-check"
                            >
                              Remember me
                            </label>
                          </div> */}
                                                {loginError ? (
                                                    <Alert color="danger" style={{ marginTop: "13px" }}>
                                                        {loginError}
                                                    </Alert>
                                                ) : null}
                                                <div className="mt-3 d-grid">
                                                    <button
                                                        className="btn btn-primary btn-block "
                                                        type="submit"
                                                    >
                                                        Log In
                                                    </button>
                                                </div>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Login2
